module.exports = __webpack_public_path__ + "static/media/pla_blo_gra.f770ac96.png";